import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTheme } from 'flowbite-react';
import { useDatePickerContext } from '../DatepickerContext';
import {
  Views,
  addYears,
  isDateInDecade,
  isDateInRange,
  startOfYearPeriod,
  mergeDeep,
} from '../helpers';

export interface FlowbiteDatepickerViewsDecadesTheme {
  items: {
    base: string;
    item: {
      base: string;
      selected: string;
      disabled: string;
    };
  };
}

export interface DatepickerViewsDecadesProps {
  theme?: FlowbiteDatepickerViewsDecadesTheme;
}

export const DatepickerViewsDecades: FC<DatepickerViewsDecadesProps> = ({
  theme: customTheme = {},
}) => {
  const theme = mergeDeep(
    useTheme().theme.datepicker.views.decades,
    customTheme
  );
  const { selectedDate, viewDate, setViewDate, setView } =
    useDatePickerContext();

  return (
    <div className={theme.items.base}>
      {[...Array(12)].map((_year, index) => {
        const first = startOfYearPeriod(viewDate, 100);
        const year = first - 10 + index * 10;
        const firstDate = new Date(year, 0, 1);
        const lastDate = addYears(firstDate, 9);

        const isSelected = isDateInDecade(viewDate, year);
        const isDisabled = !isDateInRange(viewDate, firstDate, lastDate);

        return (
          <button
            disabled={isDisabled}
            key={index}
            type="button"
            className={twMerge(
              theme.items.item.base,
              isSelected && theme.items.item.selected,
              isDisabled && theme.items.item.disabled
            )}
            onClick={() => {
              if (isDisabled) return;

              setViewDate(
                addYears(viewDate, year - selectedDate.getFullYear())
              );
              setView(Views.Years);
            }}
          >
            {year}
          </button>
        );
      })}
    </div>
  );
};
